import { render, staticRenderFns } from "./Viz.vue?vue&type=template&id=0dfbdf72&scoped=true&"
import script from "./Viz.vue?vue&type=script&lang=js&"
export * from "./Viz.vue?vue&type=script&lang=js&"
import style0 from "./Viz.vue?vue&type=style&index=0&id=0dfbdf72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfbdf72",
  null
  
)

export default component.exports